"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSpacialDataTsKeys = exports.safetyEventRingBufferFactory = exports.safetyEventSignalChartConfigurationFactory = exports.SafetyEventSignal = exports.SafetyEvent45X = exports.SafetyEvent = void 0;
var charts_1 = require("../constants/charts");
var SafetyEvent;
(function (SafetyEvent) {
    SafetyEvent["ACTIVE_SIDE_GUARD_ASSIST_BRAKING"] = "Active Side Guard Assist Braking";
    SafetyEvent["ACTIVE_SPEED_INTERVENTION_DEFUEL_EVENT"] = "Active Speed Intervention Defuel";
    SafetyEvent["COLLISION_MIT_BRAKING"] = "Collision Mitigation Braking";
    SafetyEvent["FORWARD_COLLISION_WARNING"] = "Forward Collision Warning";
    SafetyEvent["ESC_EVENT"] = "ESC Alert";
    SafetyEvent["HANDS_OFF_WHEEL_30_SEC"] = "Hands Off The Wheel Alert 30s";
    SafetyEvent["HANDS_OFF_WHEEL_60_SEC"] = "Hands Off The Wheel Alert 60s";
    SafetyEvent["LKA_AUTO_STOP_COMPLETED"] = "LKA Auto Stop Completed";
    SafetyEvent["RSC_EVENT"] = "RSC Alert";
    SafetyEvent["SEVERE_BRAKING"] = "Severe Braking";
})(SafetyEvent = exports.SafetyEvent || (exports.SafetyEvent = {}));
var SafetyEvent45X;
(function (SafetyEvent45X) {
    SafetyEvent45X["ACTIVE_SIDE_GUARD_ASSIST_STEERING"] = "Active Side Guard Assist Steering";
    SafetyEvent45X["MANUAL_EVENT"] = "Manual Event";
    SafetyEvent45X["ROLLAWAY_INTERVENTION"] = "Rollaway Intervention";
})(SafetyEvent45X = exports.SafetyEvent45X || (exports.SafetyEvent45X = {}));
var SafetyEventSignal;
(function (SafetyEventSignal) {
    SafetyEventSignal["ABA_DRIVER_OVERRIDE"] = "ABADriverOverride";
    SafetyEventSignal["ACCEL_PEDAL_POS_1"] = "AccelPedalPos1";
    SafetyEventSignal["ACTIVE_BRAKE_ASSIST_BRAKING"] = "ActiveBrakeAssistBraking";
    SafetyEventSignal["ACTIVE_LANE_ASSIST"] = "ActiveLaneAssist";
    SafetyEventSignal["ACTIVE_SIDE_GUARD_ASSIST_BRAKING"] = "ActiveSideGuardAssistBraking";
    SafetyEventSignal["ACTIVE_SIDE_GUARD_ASSIST_STEERING"] = "ActiveSideGuardAssistSteering";
    SafetyEventSignal["ACTIVE_SPEED_INTERVENTION"] = "ActiveSpeedInterventionDefuel";
    SafetyEventSignal["ADAPTIVE_CRUISE_CTRL_SET_DISTANCE_MODE"] = "AdptiveCruiseCtrlSetDistanceMode";
    SafetyEventSignal["ALA_HANDS_OFF_WHEEL"] = "ALAHandsOffWheel";
    SafetyEventSignal["AMBIENT_AIR_TEMP"] = "AmbientAirTemp";
    SafetyEventSignal["BRAKE_PEDAL_POS"] = "BrakePedalPos";
    SafetyEventSignal["COLLISION_MIT_BRAKING"] = "CollMitBraking";
    SafetyEventSignal["DIST_TO_FWD_VEH_CVAL"] = "DistToFwdVeh_Cval";
    SafetyEventSignal["ENGINE_SPEED"] = "EngSpeed";
    SafetyEventSignal["ENGINE_TORQUE"] = "EngineTorque";
    SafetyEventSignal["ESC_ALERT"] = "ESCAlert";
    SafetyEventSignal["FORWARD_COLLISION_WARNING"] = "ForwardCollisionWarning";
    SafetyEventSignal["LANE_DEPARTURE_PROTECTION"] = "LaneDepartureProtection";
    SafetyEventSignal["LANE_DEPARTURE_WARNING"] = "LaneDepartureWarning";
    SafetyEventSignal["LANE_DEPARTURE_WARNINGS"] = "LaneDepartureWarnings";
    SafetyEventSignal["LANE_DEPARTURE_WARNING_ENABLED_CMD"] = "LaneDepartureWarningEnableCmd";
    SafetyEventSignal["LANE_DPT_WARN_LT_RQ_VRDU"] = "LaneDptWarnLt_Rq_VRDU";
    SafetyEventSignal["LANE_DPT_WARN_RT_RQ_VRDU"] = "LaneDptWarnRt_Rq_VRDU";
    SafetyEventSignal["LANE_KEEP_ASSIST"] = "LaneKeepAssist";
    SafetyEventSignal["LATERAL_ACCELERATION"] = "LateralAcceleration";
    SafetyEventSignal["LONGITUDAL_ACCELERATION"] = "LongitudinalAcceleration";
    SafetyEventSignal["MANUAL_EVENT"] = "ManualEvent";
    SafetyEventSignal["ROLLAWAY_INTERVENTION"] = "RollawayIntervention";
    SafetyEventSignal["RSC_ALERT"] = "RSCAlert";
    SafetyEventSignal["SEAT_OCCUPATION"] = "SeatOccupation";
    SafetyEventSignal["SPEED_OF_FORWARD_VEHICLE"] = "SpeedofForwardVehicle";
    SafetyEventSignal["TAILGATE_WARNING"] = "DistAlertSgl_Stat_ACC";
    SafetyEventSignal["TRAFFIC_SIGN_RECOGNITION"] = "TrafficSignRecognition";
    SafetyEventSignal["TRANS_CURRENT_GEAR"] = "TransCurrentGear";
    SafetyEventSignal["TURN_SIG_LT_CMD"] = "TurnSiglLt_Cmd";
    SafetyEventSignal["TURN_SIG_RT_CMD"] = "TurnSiglRt_Cmd";
    SafetyEventSignal["WHEEL_BASED_VEHICLE_SPEED"] = "WheelBasedVehicleSpeed";
    SafetyEventSignal["YAW_RATE"] = "YawRate";
    SafetyEventSignal["TrafSign1_MPC"] = "TrafSign1_MPC";
})(SafetyEventSignal = exports.SafetyEventSignal || (exports.SafetyEventSignal = {}));
var safetyEventSignalChartConfigurationFactory = function (config) { return (__assign({ convert: undefined, maxValid: 100, minValid: -100, missingDataCondition: undefined, curve: charts_1.CurveType.LINEAR, tooltip: undefined, yAxisPointLabels: undefined, yAxisLabel: undefined }, config)); };
exports.safetyEventSignalChartConfigurationFactory = safetyEventSignalChartConfigurationFactory;
var safetyEventRingBufferFactory = function (config) { return (__assign({ EndTimestamp: '', Max: '', Min: '', Pts: '', RowKey: '', Rts: '', Signal: SafetyEventSignal.ACTIVE_BRAKE_ASSIST_BRAKING, Source: '', SpacialCount: 0, SpacialSum: 0, StartTimestamp: '', Trigger: '', TriggerType: '', Version: '', Vin: '' }, config)); };
exports.safetyEventRingBufferFactory = safetyEventRingBufferFactory;
var getSpacialDataTsKeys = function (data) { return Object.keys(data).filter(function (key) { return key.match(/T[0-9]+s/); }); };
exports.getSpacialDataTsKeys = getSpacialDataTsKeys;
